import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { BtnClickEvent, ButtonComponent } from '../shared/button/button.component';
import { IconTypes } from '../shared/icon/icon.component';
import { SpinnerComponent } from '../shared/spinner/spinner.component';
import { ObsidianTokenDTO } from '../core/models/obsidian-token.model';
import { ApiService } from '../core/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { WindowRefService } from '../core/services/windowRef.service';
import { MessageComponent } from '../shared/message/message.component';

@Component({
  selector: 'app-token',
  templateUrl: './token.component.html',
  imports: [NgIf, ButtonComponent, SpinnerComponent, MessageComponent],
})
export class TokenComponent implements OnInit {
  loaded = false;
  token?: ObsidianTokenDTO;
  issueKey = '';

  get IconTypes() {
    return IconTypes;
  }

  constructor(
    private apiService: ApiService,
    private router: Router,
    private windowRefService: WindowRefService,
    private route: ActivatedRoute,
  ) {}

  async ngOnInit(): Promise<void> {
    this.issueKey = this.route.snapshot.paramMap.get('issueKey') || '';
    this.windowRefService.AP.resize('', 350);
    await this.loadToken();
    this.loaded = true;
  }

  goBack(): void {
    this.router.navigate(['app', 'issues', this.issueKey], { queryParamsHandling: 'preserve' });
  }

  async generateToken(event: BtnClickEvent): Promise<void> {
    try {
      event.startSpinner();
      await this.apiService.post('/tokens', {});
      await this.loadToken();
      event.stopSpinner();
    } catch (error) {
      event.stopSpinner();
      console.error('Cannot generate obsidian token due to:', error);
    }
  }

  async removeToken(event: BtnClickEvent): Promise<void> {
    try {
      event.startSpinner();
      await this.apiService.delete('/tokens');
      event.stopSpinner();
      this.goBack();
    } catch (error) {
      event.stopSpinner();
      console.error('Cannot remove obsidian token due to:', error);
    }
  }

  async downloadConnector(event: BtnClickEvent): Promise<void> {
    try {
      event.startSpinner();
      const token = await this.apiService.token();
      window.open(`/api/obsidian-connectors/download?jwt=${token}`, '_blank');
      event.stopSpinner();
    } catch (error) {
      event.stopSpinner();
      console.error('Failed to download connector:', error);
    }
  }

  private async loadToken(): Promise<void> {
    try {
      this.token = await this.apiService.get<ObsidianTokenDTO>('/tokens');
    } catch (error) {
      console.error('Cannot get obsidian token due to:', error);
    }
  }
}
